import { objectfyArray } from "../helpers/objectfyArray";
import { cloneDeep } from "lodash";

const appLibrary = (
  state = {
    applications: {},
    deals: {},
    rewards: {},
    card: {},
    deleting: false,
  },
  action
) => {
  if (process.env.NODE_ENV !== "prod") console.log(action, state);
  let newState;
  switch (action.type) {
    case "TOGGLE_DELETE_EDGE_CASE":
      return {
        ...state,
        deleting: action.deleting,
      };
    case "REMOVE_APPLICATION":
      var applications = cloneDeep(state.applications);
      delete applications[action.appId];

      return {
        ...state,
        applications,
      };
    case "SET_PUNCH_CARDS_COPY":
      return {
        ...state,
        cards: objectfyArray(action.cards),
      };
    case "SET_DEALS_COPY":
      return {
        ...state,
        deals: objectfyArray(action.deals),
      };
    case "ADD_DEAL_COPY":
      return {
        ...state,
        deals: {
          ...state.deals,
          [action.deal.id]: action.deal,
        },
      };
    case "REMOVE_DEAL_COPY":
      newState = {
        ...state,
      };
      delete newState.deals[action.deal.id];
      return newState;
    case "UPDATE_DEAL_COPY":
      return {
        ...state,
        deals: {
          ...state.deals,
          [action.deal.id]: action.deal,
        },
      };
    case "SET_REWARDS_COPY":
      return {
        ...state,
        rewards: objectfyArray(action.rewards),
      };
    case "ADD_REWARD_COPY":
      return {
        ...state,
        rewards: {
          ...state.rewards,
          [action.reward.id]: action.reward,
        },
      };
    case "REMOVE_REWARD_COPY":
      newState = {
        ...state,
      };
      delete newState.rewards[action.reward.id];
      return newState;
    case "UPDATE_REWARD_COPY":
      return {
        ...state,
        rewards: {
          ...state.rewards,
          [action.reward.id]: action.reward,
        },
      };
    case "SET_APPLICATIONS":
      return {
        ...state,
        applications: objectfyArray(action.applications),
      };
    case "UPDATE_APPLICATION_LIBRARY":
      var applications = cloneDeep(state.applications);
      applications[action.application.id] = action.application;
      return {
        ...state,
        applications,
      };
    case "RESET_APPLICATIONS":
      return {
        applications: {},
        deals: {},
        rewards: {},
        cards: {},
      };
    case "RESET_OTHER_THAN_APPS":
      return {
        ...state,
        deals: {},
        rewards: {},
        cards: {},
      };
    case "REMOVE_CACHED_PHONE_NUMBER":
      const { locationIdx, phoneIdx, appId } = action;
      newState = state;
      delete newState.applications[appId].business.locations[
        locationIdx
      ].phoneNumbers.splice(phoneIdx, 1);
      return {
        ...newState,
      };
    default:
      return state;
  }
};

export default appLibrary;
